/**
 * Created by jonlazarini on 06/05/17.
 */
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_NEW_MESSAGE = 'UPDATE_NEW_MESSAGE';
export const CLEAR_NEW_MESSAGE = 'CLEAR_NEW_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

export const ATTEMPT_LOGIN = 'ATTEMPT_LOGIN';
export const SIGN_IN = 'SIGN_IN';
export const SIGNED_IN = 'SIGNED_IN';
export const SIGN_OUT = 'SIGN_OUT';

export const ADD_USER = 'ADD_USER';
exports.ERROR_SERVER = 'ERROR_SERVER';



// WEBPACK FOOTER //
// ./src/actionTypes.js